import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { Avatar } from '@/components/ui/avatar';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { LogOut } from 'lucide-react';
import { config } from '@/config';
import { cn } from '@/lib/utils';

const links = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/experiments', label: 'Experiments' },
  { to: '/decisions', label: 'Decisions' },
  { to: '/meetings', label: 'Meetings' },
  { to: '/metrics', label: 'Metrics' },
  { to: '/members', label: 'Members' },
  { to: '/docs', label: 'Docs' },
];

export function AppNav() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="bg-nav-gradient text-white shadow-nav sticky top-0 z-40">
      <div className="max-w-page mx-auto px-6 h-[60px] flex items-center justify-between">
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-2">
            <div className="font-bold tracking-tight text-base">{config.appName}</div>
            <span className="text-2xs uppercase tracking-wider opacity-60 ml-2">{config.currentPI}</span>
          </div>
          <nav className="flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) => cn(
                  'px-3 py-1.5 rounded-md text-xs font-medium transition',
                  isActive ? 'bg-white/15 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'
                )}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
        {user && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 hover:bg-white/10 rounded-full pr-3 pl-1 py-1 transition">
                <Avatar name={user.email} size="sm" className="bg-white/20 text-white" />
                <span className="text-xs">{user.email}</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <div className="px-2 py-1 text-2xs text-neutral-500">{user.isAdmin ? 'Admin' : user.isGuildMember ? 'Guild member' : 'Viewer'}</div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={async () => { await signOut(); navigate('/sign-in', { replace: true }); }}>
                <LogOut className="h-4 w-4" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </header>
  );
}
